import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { setAirline } from '../../modules/flight';
import { AIRLINES, SHOWING_HOTEL_LIMIT } from '../../constants';
import { makeHotelsInput } from '../../utils/input';
import { fetchHotels } from '../../modules/hotel';
import { useFlightList } from '../../modules/hooks/flightList';

const selector = (state) => ({
  flight: state.flight,
  hotel: state.hotel,
});

const AirlineTab = ({ handleFlightSearch }) => {
  const dispatch = useDispatch();
  const { flight, hotel } = useSelector(selector);
  const { flightsInput } = flight;
  const { hotelsInput } = hotel;

  const {
    people,
    airline,
    outbound,
    inbound,
  } = flightsInput;

  const [searchedAirline, setSearchedAirline] = useState(airline);

  const onAirlineChanged = useCallback(() => {
    const validated = handleFlightSearch();
    if (!validated) {
      return;
    }

    dispatch(
      fetchHotels(
        makeHotelsInput(hotelsInput, flightsInput),
        SHOWING_HOTEL_LIMIT,
        1
      )
    );
  }, [people, outbound, inbound, hotelsInput, handleFlightSearch]);

  useEffect(() => {
    if (airline !== searchedAirline) {
      onAirlineChanged();
      setSearchedAirline(airline);
    }
  }, [airline, searchedAirline]);

  const handleChangeAirline = (value) => {
    dispatch(setAirline(value));
  };

  const { fetched, flightDisplayList } = useFlightList();

  if (!fetched) {
    return null;
  }

  return (
    <div className="planePlanTab">
      {flightDisplayList.Jal && (
        <div
          className={`planePlanTabItem jal ${airline === AIRLINES.jal ? 'active' : ''}`}
          onClick={() => handleChangeAirline(AIRLINES.jal)}
        >
          <img className="jalIcon" src="/dp-air/img/logo/Jal.jpg" alt=""/>
          {airline === AIRLINES.jal && (
            <div className="iconTriangle" />
          )}
        </div>
      )}
      {flightDisplayList.Ana && (
        <div
          className={`planePlanTabItem ${airline === AIRLINES.ana ? 'active' : ''}`}
          onClick={() => handleChangeAirline(AIRLINES.ana)}
        >
          <img src="/dp-air/img/logo/Ana.svg" alt=""/>
          {airline === AIRLINES.ana && (
            <div className="iconTriangle ana " />
          )}
        </div>
      )}
    </div>
  );
};

AirlineTab.propTypes = {
  handleFlightSearch: PropTypes.func.isRequired,
};

export default AirlineTab;
